// pt-BR strings for the Plan 7 'atividades' namespace (t('atividades.…')), kept apart so each screen's strings live in one file.
export const atividadesPt = {
  title: 'Atividades',
  subtitle: '{{date}} · dados até {{asOf}}',
  scope: { label: 'Filtrar', all: 'Todos', env_outside: 'Ambiental (sem processo minerário)', sei_outside: 'SEI (sem processo minerário)' },
  tabs: {
    label: 'Atividades',
    geral: 'Visão geral',
    prazos: 'Prazos',
    movimentacoes: 'Movimentações',
  },
  origins: { anm: 'ANM', env: 'Ambiental', fin: 'Financeiro' },
  kpi: {
    overdue: 'Vencidos',
    next30: 'Próximos 30 dias',
    next90: 'Próximos 90 dias',
    movements30: 'Movimentações · 30 dias',
    noneOverdue: 'nenhum prazo vencido',
    byOrigin: '{{count}} {{origin}}',
    until: 'nenhum prazo até {{date}}',
    nextOne: 'próximo: {{what}} · {{date}}',
    noMovements: 'nenhuma nos últimos 30 dias',
    bySource: '{{count}} {{source}}',
    unavailable: 'prazos indisponíveis',
  },
  timeline: {
    title: 'Linha do tempo dos prazos',
    group: 'Escolher um período',
    quick: 'Atalhos',
    late: 'Vencidos',
    later: 'Depois',
    undated: 'Sem data',
    soon: '90 dias',
    all: 'Tudo',
    column_zero: '{{label}}: nenhum prazo',
    column_one: '{{label}}: {{count}} prazo',
    column_other: '{{label}}: {{count}} prazos',
    failed: 'Não foi possível carregar os prazos agora. Tente recarregar a página — até lá, não afirmamos que nada vence.',
  },
  months: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
  list: {
    late: 'Exige ação · vencidos',
    soon: 'Vencidos e próximos 90 dias',
    all: 'Todos os prazos',
    column: 'Prazos · {{label}}',
    undated: 'Prazos sem data',
    empty: 'Nenhum prazo neste período.',
    allPrazos: 'Todos os prazos →',
  },
  recent: {
    title: 'Movimentações recentes',
    all: 'Ver todas →',
    none: 'Nenhuma movimentação recente.',
  },
  movimentacoes: {
    filters: 'Filtrar movimentações',
    authority: 'Fonte',
    authorities: { all: 'Todas as fontes', anm: 'ANM', ibama: 'IBAMA', iat_pr: 'IAT-PR', ima_sc: 'IMA-SC' },
    process: 'Processo',
    allProcesses: 'Todos os processos',
    period: 'Período',
    periods: { d30: 'Últimos 30 dias', d90: 'Últimos 90 dias', d365: 'Últimos 12 meses', all: 'Todo o histórico' },
    range: 'De {{from}} a {{to}}',
    none: 'Nenhuma movimentação com esses filtros.',
    more: 'Carregar mais',
    loadingMore: 'Carregando…',
  },
} as const;
